import { formatValue } from '@arco-design/web-react/es/Input/input';
import { isNumber, round } from 'lodash-es';
import { memo } from 'react';

interface BaseNumberProps {
	num?: number;
	hasPlusSign?: boolean;
	count?: number; // 保留几位
	className?: string;
	style?: React.CSSProperties;
}

export function formatNumber(value?: number, count: number = 1, isRtl: boolean = document.documentElement.getAttribute('dir') === 'rtl') {
	if (!isNumber(value)) {
		return '';
	}
	if (value >= 1e9) {
		const formattedValue = round(value / 1e9, count);
		return isRtl ? `B${formattedValue}` : `${formattedValue}B`;
	} else if (value >= 1e6) {
		// 千万数，添加 M
		const formattedValue = round(value / 1e6, count);
		if (formattedValue >= 1000) {
			const bValue = round(value / 1e9, count);
			return isRtl ? `B${bValue}` : `${bValue}B`;
		}
		return isRtl ? `M${formattedValue}` : `${formattedValue}M`;
	} else if (value >= 1000) {
		// 千位数，添加 K
		const formattedValue = round(value / 1000, count);
		if (formattedValue >= 1000) {
			const bValue = round(value / 1e6, count);
			return isRtl ? `M${bValue}` : `${bValue}M`;
		}
		return isRtl ? `K${formattedValue}` : `${formattedValue}K`;
	} else {
		// 小于千的数
		return value.toString();
	}
}

export const BaseNumber = memo((props: BaseNumberProps) => {
	const { num, hasPlusSign = false, count = 1, className, style } = props;

	let formatValue = formatNumber(num, count);
	if (num && hasPlusSign && num >= 1000) formatValue += '+';

	return (
		<span className={className} style={style}>
			{formatValue}
		</span>
	);
});
